import ThemeConfig from '../theme-config';

const themeConfig: ThemeConfig = {
  data: {
    url: 'https://karriere.wupperverband.de/jobPublication/list.json',
    language: 'de',
  },
  styles: {
    brandColor: '#384c92',
    fontFamily: 'Arial, sans-serif',
    fontSize: '14px',
    textColor: '#373535',
    borderRadius: '0px',
    headlineStyle: {
      color: '#373535',
      fontSize: '18px',
    },
    labelStyle: {
      color: '#373535',
      fontSize: '18px',
    },
  },
  ui: {
    theme: undefined,
    jobsPerPage: 16,
  },
  filters: {
    categories: { enabled: false },
    locations: { enabled: false },
    targetGroups: { enabled: false },
  },
};

export default themeConfig;
